import { useInfiniteQuery, type InfiniteData } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { propostaKeys } from '@/features/proposta/brasil/utils'
import { GetListarImobiliariasCorretoresService } from '@/features/proposta/shared/http/get-imobiliarias-corretores.service'
import type {
  TGetListaDeImobiliariasCorretoresParams,
  TGetListaDeImobiliariasCorretoresResponse,
  TImobiliariaCorretor,
} from '@/features/proposta/shared/types'
import { CINCO_MINUTOS } from '@/utils/constants'

type TListarImobiliariasCorretoresResponse = TGetListaDeImobiliariasCorretoresResponse<TImobiliariaCorretor>

export const useListarImobiliariasCorretores = (query: Partial<TGetListaDeImobiliariasCorretoresParams>) =>
  useInfiniteQuery<
    TListarImobiliariasCorretoresResponse,
    AxiosError,
    InfiniteData<TListarImobiliariasCorretoresResponse>,
    ReturnType<typeof propostaKeys.listaImobiliariasCorretores>,
    number
  >({
    retry: false,
    queryKey: propostaKeys.listaImobiliariasCorretores(query),
    queryFn: ({ pageParam }) =>
      new GetListarImobiliariasCorretoresService()
        .execute({ paginaCorrente: pageParam, ...query })
        .then((res) => res.data),
    initialPageParam: 1,
    getNextPageParam: ({ metadata: { paginaCorrente, totalDePaginas } }, todasPaginas) =>
      totalDePaginas > paginaCorrente ? todasPaginas.length + 1 : undefined,
    staleTime: CINCO_MINUTOS,
  })
